import config from '../../../config.json'
import printConfig from '../../../print-config.json'
import Translation from '../../Translation/cont/Translation';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import { Link } from 'react-router-dom';
import sortAlphabetical from '../../FlyerPreview/func/sortAlphabetical';

const ChooseTechnical = ({
    cinemaId,
    printType, 
    printID, 
    printPk,
    landscape,
    attributes,
    week,
    closePagePath,
}) => {
    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })
    const path = `${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${printPk}/${currentPrintFormat.landscape}/${week}`
    
    if(!attributes || !attributes.technical) {
        return ''
    }

    const sortedAttributes = attributes ? sortAlphabetical(_.keys(attributes.technical)) : null
    
    return (
        <WrapperPageSimple
            pageTitleTransId={printConfig.routes[printType].transIdname} 
            closePagePath={closePagePath}
        >
            <div className="program-page program-page-choose-technical flyer print-page site-content">
                <div>
                    <h3 className="gap-20 title-list text-regular"><Translation id="section_filter_select_film_series_title">Filmreihe auswählen</Translation></h3>

                    <div className="title-list gap-30">
                        <Link className={"button-wrapper"} to={`${path}/all/edit`}>
                            <button className={"button button-text"}><Translation id="print_select_all_movies"/></button>
                        </Link>
                    </div>

                    <div className="title-list gap-30">
                        {sortedAttributes.map((attrId, index) => {
                            const attr = attributes.technical[attrId]
                            const {name} = attr
                            
                            return <Link key={index} className={"button-wrapper"} to={`${path}/${attrId}/edit`}>
                                <button className={"button button-text"}>{name}</button>
                            </Link>
                        })}
                    </div>
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default ChooseTechnical